/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .factory("AgencySrv", function ($rootScope, $resource) {
    return $resource(
      $rootScope.globalConfig.apipath + "/agency/:id",
      { id: this.id },
      {
        update: {
          method: "PUT",
        },
      }
    )
  })
